import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ReportsList from './NewReportsList';
import {indexReports} from '../Module';

@connect((state) => ({
  newReports: state.Attendance.Reports.newReports,
}), {
  indexReports,
})
@autobind
/**
 *
 * @class NewReportsListWrapper
 * @extends PureComponent
 */
export default class NewReportsListWrapper extends React.PureComponent {
  static propTypes = {
    indexReports: PropTypes.func,
    newReports: PropTypes.arrayOf(PropTypes.object),
    activeItem: PropTypes.number,
    onClick: PropTypes.func,
    menu: PropTypes.func,
    extra: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
    ]),
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {indexReports} = this.props;

    this.setState({loading: true});

    indexReports( () => this.setState({loading: false}));
  }

  /**
   *
   * @param {String} value
   * @private
   */
  _onSearch(value) {
    const {indexReports} = this.props;

    this.setState({loading: true}, () => indexReports({
      filterGroups: [
        {
          or: true,
          filters: [
            {
              key: 'name',
              value,
              operator: 'ct',
            },
            {
              key: 'description',
              value,
              operator: 'ct',
            },
          ],
        },
        {
          filters: [
            {
              key: 'type',
              value: 'report',
              operator: 'eq',
            },
          ],
        },
      ],
    }, () => this.setState({loading: false})));
  }

  /**
   *
   * @return {Object}
   * @private
   */
  _pagination() {
    return {};
  }


  /**
   *
   * @return {ListWrapper.props.newReports}
   * @private
   */
  _dataSource() {
    let {newReports} = this.props;
    app._.map(newReports, (rule) => {
      rule.icon = (rule.type === 'rule' ? 'gavel' : 'file-chart');
    });
    return newReports;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {activeItem, onClick, menu, extra, ...rest} = this.props;
    const {loading} = this.state;

    return (
      <ReportsList
        items={this._dataSource()}
        loading={loading}
        onSearch={this._onSearch}
        pagination={this._pagination()}
        activeItem={activeItem}
        onClick={onClick}
        menu={menu}
        extra={extra}
        {...rest}
      />
    );
  }
}
